import React from 'react'
import { useTranslation } from 'react-i18next'
import { Grid } from '@material-ui/core'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'

const ScanInsightsEmptyState = () => {
  const { t } = useTranslation()

  return (
    <Grid container alignItems="center" justifyContent="center" style={{ height: '100%' }}>
      <Grid item>
        <DazzedParagraph14 strong textAlign="center" color="var(--text-color-18)">
          {t('pages.patients.patientSidebar.items.copilot.copilotInsights.noDataAvailable')}
        </DazzedParagraph14>
      </Grid>
    </Grid>
  )
}

export default ScanInsightsEmptyState
